import { isAuthenticated } from '@cronos-app/api';
import { getBrowserProvider } from '@cronos-app/sdk/dist/esm/utils';
import { currentWallet } from '@cronos-app/wallet';

import { signAndLogin } from './signAndLogin';

// compare similar code in web3 wallet library
export const ensureIsAuthenticated = async (): Promise<boolean> => {
  const _provider = currentWallet.getConnector().provider;
  if (!_provider) return false;
  const walletAddress = currentWallet.getStore().getState().accounts?.[0];
  const chainId = currentWallet.getStore().getState().chainId ?? 0;
  if (!chainId) return false;
  const provider = getBrowserProvider(_provider, chainId);
  if (!walletAddress) return false;
  try {
    const authenticated =
      !!walletAddress && (await isAuthenticated(walletAddress));
    if (authenticated) return true;
    return await signAndLogin(walletAddress, provider);
  } catch (error) {
    console.error('Error ensuring authentication:', error);
    return false;
  }
};
